import { HelpParameters, Help, HelpPanelColor } from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
import { Panel, ButtonColors } from "../panel/panel";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_2Screen } from "../SlotGameType1_2Screen";
import { IWinLinesFactory } from "../WinLines/IWinLinesFactory";
import { SquareWinLinesFactory } from "../WinLines/SquareWinLineFactory";
import {  AudioManager} from "../../AudioManager";
// namespace SlotGames {

    export class BambooSecrets_2Screen extends SlotGameType1_2Screen {

        
        //protected panelFactory: IPanelFactory = new BambooSecretsPanelFactory();
        protected override helpFactory: IHelpFactory = new BambooSecretsHelpFactory();
        //LED COLOR
        protected override ColorLed: string = "57,255,20\n";
        //SEND COLOR FOR RSA 
        protected override color: RewardColor =
            {
                color: "#96DB2A",
                coloroutherStroke: "black",
                colorinnerStroke: "#DB3814",
            }

        constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
            super(multigameParams, initData, "BambooSecrets");
            this.spinnableReelsParams.topBorderWidth = 7;
            this.spinnableReelsParams.bottomBorderWidth = 7;
        }
    }

    //Panel Colorized
    class BambooSecretsPanelFactory implements IPanelFactory {
        public CreateNewPanel(params: PanelParams): Panel {
            return new BambooSecretsPanel(params);
        }
    }

    class BambooSecretsPanel extends Panel {
        protected override ButtonBackground(): ButtonColors {
            let color: ButtonColors = {
                backgroundButtonColor: "linear-gradient(rgb(14, 38, 8),rgb(42, 89, 21), rgb(68, 140, 35),rgb(42, 89, 21),rgb(14, 38, 8)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
                linearColor: "linear-gradient(to left , transparent, yellowgreen,transparent ) 0 10 100%",
            };
            return color;

        }

    }


    //Help Colorized
    class BambooSecretsHelpFactory implements IHelpFactory {
        public CreateNewHelp(params: HelpParameters): Help {
            return new BambooSecretsHelp(params);
        }
    }

    class BambooSecretsHelp extends Help {
        protected override BackgroundPanel(): HelpPanelColor {
            let color: HelpPanelColor = {
                backgroundPanelColor: "linear-gradient(rgb(14, 38, 8),rgb(42, 89, 21), rgb(68, 140, 35),rgb(42, 89, 21),rgb(14, 38, 8)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
            };

            return color;
        }
    }

// }
